
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import * as firebaseSelectors from '../../../Core/Firebase/firebase.selectors'

import * as battlesSelectors from '../../Battles/battles.selectors'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as activitySelectors from '../../Activity/activity.selectors'
import * as miningSelectors from '../../Mining/mining.selectors'

import * as eventsActions from '../../Events/events.actions'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as actions from '../phases.actions'
import * as activityActions from '../../Activity/activity.actions'
import * as gameActions from '../../../Core/Game/game.actions'

import Phase1Screen from './Phase1Screen'

const mapStateToProps = (state) => ({
  groupData: firebaseSelectors.getGroupData(state),
  indicators: indicatorsSelectors.getUserData(state),
  disputesInfo: activitySelectors.getDisputesInfo(state),
  debatesInfo: activitySelectors.getDebatesInfo(state),
  MISInfo: activitySelectors.getMISInfo(state),
  currentUser: firebaseSelectors.getUserData(state),
  battlesInfo: activitySelectors.getBattlesInfo(state),
  rivalInfo: battlesSelectors.getRivalInfo(state),
  playersList: firebaseSelectors.getPlayerList(state),
  relativeTurn: indicatorsSelectors.getRelativeTurn(state),
  totalLikes: miningSelectors.getTotalLikes(state),
})

const mapDispatchToProps = (dispatch) => ({
  loadEvent: bindActionCreators(eventsActions.loadEvent, dispatch),
  nextPhase: bindActionCreators(actions.nextPhase, dispatch),
  addScreen: bindActionCreators(gameActions.addScreen, dispatch),
  loadActivity: bindActionCreators(activityActions.loadActivityData, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Phase1Screen))
